import { SignIn } from "@clerk/react";
import { AuthLoading, AuthShell } from "./AuthShell";
import { authUrl, defaultAuthDestination } from "./destination";
import { clerkAppearance } from "./clerkAppearance";

export function LoginPage({ destination }: { destination: string }) {
  return <AuthShell><SignIn
    path="/login" routing="path" withSignUp={false} signUpUrl={authUrl("signup", destination)}
    fallbackRedirectUrl={defaultAuthDestination} signUpFallbackRedirectUrl={defaultAuthDestination}
    // Return to the auth boundary so SignalBill bootstrap finishes before navigation.
    // Force URLs also prevent Clerk's own redirect_url parameter bypassing validation.
    forceRedirectUrl={authUrl("login", destination)} signUpForceRedirectUrl={authUrl("signup", destination)}
    appearance={clerkAppearance} fallback={<AuthLoading title="Sign in to SignalBill" />}
  /></AuthShell>;
}
